import React from 'react';
import { Box, Typography } from '@mui/material';
import MedChip from './MedChip';

const MAX_CHIPS = 3;

export default function CalendarCell({ date, day, dow, isToday, isSelected, meds, onClick }) {
    const isSunday = dow === 0;
    const isSaturday = dow === 6;
    const numColor = isToday
        ? '#fff'
        : isSunday
            ? '#ef4444'
            : isSaturday
                ? '#3b82f6'
                : '#1a1a1a';

    const visible = meds.slice(0, MAX_CHIPS);
    const overflow = meds.length - visible.length;

    return (
        <Box
            data-date={date}
            role="button"
            tabIndex={0}
            onClick={onClick}
            sx={{
                minHeight: 76,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                padding: '6px 2px 4px',
                bgcolor: isSelected ? '#fafafa' : '#fff',
                border: isSelected ? '1px solid #ececec' : '1px solid transparent',
                borderRadius: '10px',
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'background 0.15s ease',
                '&:active': { transform: 'scale(0.98)' },
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: '4px' }}>
                <Box
                    sx={{
                        width: 22,
                        height: 22,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: isToday || isSelected ? '50%' : 0,
                        bgcolor: isToday ? '#2563eb' : isSelected ? '#dbeafe' : 'transparent',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '13px',
                            fontWeight: 600,
                            color: numColor,
                            lineHeight: 1,
                        }}
                    >
                        {day}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1 }}>
                {visible.map((m) => (
                    <MedChip key={m.key} name={m.name} isGroup={m.isGroup} color={m.color} status={m.status} />
                ))}
                {overflow > 0 && (
                    <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#777', padding: '1px 4px', lineHeight: 1.2 }}>
                        +{overflow}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
